import { FC } from 'react';
import { Stack } from '@mui/material';
import { InputText, InputTextArea } from '@farmshare/ui-components';
import { ImageUploadInput } from '../builder/image-upload-input';

interface InfoSlideQuestionFormProps {
  /** The capability set ID used to group uploaded images in S3. */
  capabilityId: string;
}

/**
 * Form for creating/editing Info Slide questions
 * Displays informational content with title, details, and optional image
 * Used with useModal pattern
 * @param props - Component props
 * @param props.capabilityId - The capability set ID for S3 image grouping
 * @returns Info slide question form component
 */
export const InfoSlideQuestionForm: FC<InfoSlideQuestionFormProps> = ({
  capabilityId,
}) => (
  <Stack spacing={3}>
    <InputText label="Slide Title" nameOverride="title" required />

    <InputTextArea
      label="Description"
      nameOverride="description"
      rows={2}
      hint="Brief subtitle or summary for this informational slide"
    />

    <InputTextArea
      label="Details"
      nameOverride="details"
      rows={6}
      hint="Main content shown on the slide. Start a line with • or - to create bullet points."
    />

    <ImageUploadInput
      nameOverride="imageUrl"
      label="Image"
      capabilityId={capabilityId}
    />
  </Stack>
);
